import React, { useState } from "react";
import axios from "axios";
import { url } from "../../utils/confserveur";
function ChangePassword() {
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState('')
    const handleSubmit = async (e) => {
        e.preventDefault();

       
        if (newPassword !== confirmPassword) {
            setError("Les nouveaux mots de passe ne correspondent pas");
            return;
        }

        // Valider la complexité du mot de passe ici
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{12,}$/;
        if (!passwordRegex.test(newPassword)) {
            setError("Le mot de passe doit comporter au moins 12 caractères, avec des majuscules, minuscules, chiffres, et caractères spéciaux.");
            return;
        }
        try {
            const response = await axios.post(url + 'api/change_password/', {
                old_password: oldPassword,
                new_password: newPassword,
            }, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('access_token')}`
                }
            });

            if (response.data.success) {
                setSuccess(response.data.success);
                setError('');
            } else {
                setError(response.data.error);
                setSuccess('');
            }
        } catch (err) {
            setError(err.response.data.error);
            setSuccess('');
        }

        // Appeler l'API pour changer le mot de passe
       
    };

    return (
       !success ?  <form onSubmit={handleSubmit} className=" text-xl  ">
            <div>
                <label>Ancien mot de passe :</label>
                <input
                className=" border-2 border-slate-400 m-2 rounded"
                    type="password"
                    value={oldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                />
            </div>
            <div>
                <label>Nouveau mot de passe :</label>
                <input
                 className=" border-2 border-slate-400 m-2 rounded"
                    type="password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                />
            </div>
            <div>
                <label>Confirmer le nouveau mot de passe :</label>
                <input
                    type="password"
                     className=" border-2 border-slate-400 m-2 rounded"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                />
            </div>
            {error && <p style={{ color: "red" }}>{error}</p>}
            <div className=" flex m-2 justify-center"><button className="button border-2 bg-sky-300 rounded-2xl p-2 font-bold " type="submit">Changer le mot de passe</button>
            </div> 
        </form> 


: <p style={{ color: "green" }}>{success}</p>

    );
}

export default ChangePassword;